import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useWindRoseStore = create(
  persist(
    set => ({
      vtype: 'R16',
      intervals: true,
      chartFormat: 'svg',
      interactive: false,

      setVtype: vtype => set({ vtype }),
      setIntervals: intervals => set({ intervals }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'windrose-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
